// ====================================================
// 11.11 SALE PROMOTIONS
// CEILING FANS ONLY
// Offer Ends: 14 November 2026
// ====================================================

(() => {
  "use strict";

  // ====================================================
  // CURRENT PRODUCT HANDLE
  // ====================================================

  const prodHandle = location.pathname.split("/").pop();


  // ====================================================
  // CEILING FANS
  // ====================================================

  const ceilingFanProducts = [
    "prism-oasis",
    "oasis-pro",
    "oasis-pro-macaron"
  ];


  // ====================================================
  // STOP IF NOT A CEILING FAN
  // ====================================================

  if (!ceilingFanProducts.includes(prodHandle)) {
    return;
  }


  // ====================================================
  // HELPER
  // ====================================================

  function createBanner(
    img,
    title,
    desc,
    extra = "",
    freeTag = "11.11 SALE"
  ) {

    const wrapper = document.createElement("div");

    wrapper.className = "free_gift_banner layout2";

    wrapper.innerHTML = `
      <div class="free-gift comex">

        <img src="${img}" alt="">

        <div class="info-wrapper">

          <div class="title-wrapper">
            <span class="free-tag">${freeTag}</span>
            <span class="title">${title}</span>
          </div>

          ${
            desc
              ? `<p class="description">${desc}</p>`
              : ""
          }

          ${
            extra
              ? `<span class="description red">${extra}</span>`
              : ""
          }

        </div>

      </div>
    `;

    return wrapper;
  }


  // ====================================================
  // FAN PROMOTION BANNER
  // ====================================================
  
  function getCeilingFanWarrantyBanner() {

    return createBanner(
      "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/CeilingFans_4842b69c-b529-4dab-a2a9-c794fa94e146.png?v=1790770749",
      "Warranty extended from 1 year to 4 years full warranty, all parts + labour",
      "For all Oasis Fan models",
      "Offer ends 14 November"
    );

  }
  


  // ====================================================
  // CREATE BANNER
  // ====================================================

  const banner = getCeilingFanWarrantyBanner();


  // ====================================================
  // INJECT BANNER
  // ====================================================

  function inject() {

    const target =
      document.querySelector('[itemprop="offers"]') ||
      document.querySelector(".variant-selector") ||
      document.querySelector(".product-form");

    if (!target || !target.parentNode) {
      return;
    }

    target.parentNode.insertBefore(
      banner,
      target
    );

  }


  // ====================================================
  // DOM READY
  // ====================================================

  if (document.readyState === "loading") {

    document.addEventListener(
      "DOMContentLoaded",
      inject
    );

  } else {

    inject();

  }

})();


// ====================================================
// FAN GROUPSELL WARRANTY TEXT
// ====================================================

(() => {
  "use strict";

  // ====================================================
  // CEILING FAN PRODUCTS
  // ====================================================

  const ceilingFanProducts = [
    "prism-oasis",
    "oasis-pro",
    "oasis-pro-macaron"
  ];

  const prodHandle = location.pathname.split("/").pop();


  // ====================================================
  // ONLY RUN ON CEILING FAN PDPs
  // ====================================================

  if (!ceilingFanProducts.includes(prodHandle)) {
    return;
  }


  // ====================================================
  // WARRANTY TEXT
  // ====================================================

  const warrantyText =
    "Standard Warranty: 4-Year Parts & Labour Warranty on LED Panel & Components (Excludes Remote & Receiver) + Lifetime Motor Warranty";


  // ====================================================
  // UPDATE WARRANTY CONTENT
  // ====================================================

  function updateWarrantyText() {

    // --------------------------------------------------
    // ADD-ON: EXTENDED WARRANTY
    // --------------------------------------------------

    const groupsellWarranty =
      document.querySelector(".groupsell-title span") ||
      document.querySelector(".groupsell-wrap-second .subtitle");

    if (groupsellWarranty) {
      groupsellWarranty.textContent = warrantyText;
    }


    // --------------------------------------------------
    // LIFETIME WARRANTY SECTION
    // Oasis / section-7
    // --------------------------------------------------

    const warrantySection =
      document.querySelector(".section-7");

    if (warrantySection) {

      const warrantyParagraph =
        warrantySection.querySelector(
          ".text-wrap .page-width > p"
        );

      if (warrantyParagraph) {

        warrantyParagraph.textContent =
          "Enjoy comprehensive warranty coverage with PRISM+. Benefit from a Lifetime Motor Warranty, 4-Year LED Panel Warranty, and 2-Year Warranty on the Remote Control & Receiver. Our expert technicians also provide professional servicing and installation for complete peace of mind.";

      }

    }

  }


  // ====================================================
  // RUN
  // ====================================================

  if (document.readyState === "loading") {

    document.addEventListener(
      "DOMContentLoaded",
      updateWarrantyText,
      { once: true }
    );

  } else {

    updateWarrantyText();

  }

})();


// ====================================================
// PRISM+ CEILING FAN WARRANTY UPDATE
// ====================================================

(function () {
  "use strict";


  // ====================================================
  // SETTINGS
  // ====================================================

  var LED_YEARS = "4 years";
  var LED_YEARS_SLICE = "4 Years";

  var LABOUR_YEARS = "4 years";
  var LABOUR_YEARS_SLICE = "4 Years";

  var NEW_BADGE =
    "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/badge-5yrs.png?v=1767765456";


  // ====================================================
  // FAN PAGE DETECTION
  // ====================================================

  function isFanPage() {

    var pageText = document.body
      ? document.body.textContent.toLowerCase()
      : "";

    return (
      pageText.indexOf("natural wind") !== -1 ||
      (
        pageText.indexOf("smart mobile app") !== -1 &&
        pageText.indexOf("ceiling fan") !== -1
      )
    );

  }


  // ====================================================
  // HELPER
  // ====================================================

  function cleanText(text) {

    return String(text || "")
      .replace(/\s+/g, " ")
      .trim()
      .toLowerCase();

  }


  // ====================================================
  // 1. COMPARISON TABLE
  // ====================================================

  function updateComparisonTables() {

    var tables = document.querySelectorAll(
      ".comparison-chart table, .table-chart table"
    );

    tables.forEach(function (table) {

      var rows = table.querySelectorAll("tr");

      rows.forEach(function (row) {

        var titleCell = row.querySelector("td.title");

        if (!titleCell) {
          return;
        }

        var title = String(titleCell.textContent || "")
          .replace(/\s+/g, " ")
          .trim()
          .toLowerCase();

        var newValue = null;

        if (title === "led panel") {
          newValue = "4 years";
        }

        if (title === "labour & transport") {
          newValue = "4 years";
        }

        if (!newValue) {
          return;
        }

        var cells = Array.from(row.children);
        var titleIndex = cells.indexOf(titleCell);

        if (titleIndex === -1) {
          return;
        }

        var prismSmart = cells[titleIndex + 1];
        var prismStandard = cells[titleIndex + 3];

        if (prismSmart) {
          prismSmart.textContent = newValue;
        }

        if (prismStandard) {
          prismStandard.textContent = newValue;
        }

      });

    });

  }


  // ====================================================
  // 2. LIFETIME WARRANTY
  // ====================================================

  function updateLifetimeWarranty() {

    var sections = document.querySelectorAll(
      ".section-8, .pdp-section"
    );

    sections.forEach(function (section) {

      var sectionText = cleanText(section.textContent);

      if (
        sectionText.indexOf("quality assurance") === -1 ||
        sectionText.indexOf("lifetime warranty") === -1
      ) {
        return;
      }

      var items = section.querySelectorAll(
        ".text-flex .text-item"
      );

      items.forEach(function (item) {

        var labelElement = item.querySelector(
          ".subtitle-text"
        );

        if (!labelElement) {
          labelElement = item.querySelector("p");
        }

        if (!labelElement) {
          return;
        }

        var label = cleanText(
          labelElement.textContent
        );

        // LED

        if (
          label === "led" ||
          label.indexOf("led") === 0
        ) {

          setWarrantyValue(
            item,
            LED_YEARS_SLICE
          );

        }

        // Labour & Transport

        if (
          label.indexOf("labour & transport") !== -1
        ) {

          setWarrantyValue(
            item,
            LABOUR_YEARS_SLICE
          );

        }

      });

    });

  }


  function setWarrantyValue(item, value) {

    // Macaron

    var strong = item.querySelector("strong");

    if (strong) {
      strong.textContent = value;
      return;
    }

    // Oasis / Oasis Pro

    var smallText = item.querySelector(".smalltxt");

    if (smallText) {
      smallText.textContent = value;
      return;
    }

    // Fallback

    var paragraphs = item.querySelectorAll("p");

    if (paragraphs.length > 1) {

      paragraphs[
        paragraphs.length - 1
      ].textContent = value;

    }

  }


  // ====================================================
  // 3. BASIC WARRANTY / TECH SPECS
  // ====================================================

  function updateBasicWarranty() {

    var tables = document.querySelectorAll(
      ".vwo_specBlock.warranty table"
    );

    tables.forEach(function (table) {

      var rows = table.querySelectorAll("tr");

      rows.forEach(function (row) {

        var heading = row.querySelector("th");

        if (!heading) {
          return;
        }

        var title = cleanText(
          heading.textContent
        );

        var newValue = null;

        if (title === "led panel") {
          newValue = LED_YEARS;
        }

        if (title === "labour & transport") {
          newValue = LABOUR_YEARS;
        }

        if (!newValue) {
          return;
        }

        var cells = row.querySelectorAll("td");

        if (cells.length) {
          cells[0].textContent = newValue;
        }

      });

    });

  }


  // ====================================================
  // 4. EXTENDED WARRANTY BADGE
  // ====================================================

  function updateExtendedWarrantyBadge() {

    var headings = document.querySelectorAll(
      "h1, h2, h3, h4, p, span"
    );

    headings.forEach(function (heading) {

      if (
        cleanText(heading.textContent) !==
        "premium extended warranty"
      ) {
        return;
      }

      var section = heading.closest(
        ".section-9a, .product-info-sc, .shopify-section"
      );

      if (!section) {
        return;
      }

      var images = section.querySelectorAll("img");

      images.forEach(function (img) {

        var src = (
          img.getAttribute("src") || ""
        ).toLowerCase();

        if (
          src.indexOf("badge_3-5") !== -1 ||
          src.indexOf("badge-5yrs") !== -1
        ) {

          img.setAttribute(
            "src",
            NEW_BADGE
          );

          img.removeAttribute("srcset");

          img.setAttribute(
            "alt",
            "5 Years Extended Warranty"
          );

        }

      });

    });

  }


  // ====================================================
  // RUN
  // ====================================================

  function updateFanWarranty() {

    if (!isFanPage()) {
      return;
    }

    updateComparisonTables();
    updateLifetimeWarranty();
    updateBasicWarranty();
    updateExtendedWarrantyBadge();

  }


  // ====================================================
  // INITIAL RUN
  // ====================================================

  if (document.readyState === "loading") {

    document.addEventListener(
      "DOMContentLoaded",
      updateFanWarranty
    );

  } else {

    updateFanWarranty();

  }


  // ====================================================
  // DYNAMIC CONTENT
  // ====================================================

  var updateTimer = null;

  var observer = new MutationObserver(function () {

    clearTimeout(updateTimer);

    updateTimer = setTimeout(function () {

      updateFanWarranty();

    }, 150);

  });


  if (document.body) {

    observer.observe(
      document.body,
      {
        childList: true,
        subtree: true
      }
    );

  }

})();